export default __webpack_public_path__ + "cardModelNlp-real3b3b02.png";